import * as React from "react";

import styles from "./DeadlineCard.module.css";

export interface DeadlineCardProps {
  label: string;
  date: string;
  note?: string;
  noteBg?: string;
  noteColor?: string;
  className?: string;
}

/** Small stat card for a deadline (uppercase label, date, colored note pill). */
export const DeadlineCard: React.FC<DeadlineCardProps> = ({ label, date, note, noteBg, noteColor, className }) => (
  <div className={`${styles.card}${className ? ` ${className}` : ``}`}>
    <div className={styles.label}>{label}</div>
    <div className={styles.date}>{date}</div>
    {note && (
      <div className={styles.note} style={{ background: noteBg, color: noteColor }}>
        {note}
      </div>
    )}
  </div>
);
